import {
  AUDIO_BAR_OFFSET_PROPERTY,
  AUDIO_BAR_REST_OFFSET_PROPERTY,
  audioBarHeightToOffset,
  restingAudioBarOffset,
  setAudioBarHeight,
} from '../audio-bar';

export type BarSize = 'default' | 'compact';

export const BAR_OFFSET_PROPERTY = AUDIO_BAR_OFFSET_PROPERTY;
export const BAR_REST_OFFSET_PROPERTY = AUDIO_BAR_REST_OFFSET_PROPERTY;

export const BAR_HEIGHT_RANGE: Record<BarSize, { min: number; max: number }> = {
  default: { min: 8, max: 20 },
  compact: { min: 3, max: 12 },
};

export const barHeightToOffset = (height: number, size: BarSize): string => {
  return audioBarHeightToOffset(height, BAR_HEIGHT_RANGE[size]);
};

export const restingBarOffset = (size: BarSize): string =>
  restingAudioBarOffset(BAR_HEIGHT_RANGE[size]);

/** Compare the quantized offset so saturated inputs do not repeat CSSOM writes. */
export const setBarHeight = (
  bar: HTMLDivElement,
  height: number,
  size: BarSize
): boolean => {
  return setAudioBarHeight(bar, height, BAR_HEIGHT_RANGE[size]);
};
